/**
 * @module components/Form/FormGroupSiteDesignationXS
 * @author Charles Blais <charles.blais@canada.ca>
 *
 * Form group for site desination XS
 */

import React from 'react';

import { Row, Col, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

import { useLanguageState } from '../../contexts/language-state-provider';

import { useAppState } from '../../contexts/app-state-provider';


type Props = {
  value?: string,
  onChange: React.FormEventHandler<ToggleButton>
}


/**
 * React component
 * ===============
 */
const FormGroupSiteDesignationXS = ({
  value,
  onChange,
}: Props) => {
  const [ lang ] = useLanguageState();
  const [ state ] = useAppState();

  let info = null
  if (value && value in state.form.siteDesignationsXSOptionsRange) {
    const range = state.form.siteDesignationsXSOptionsRange[value];
    if( lang.abbr === 'fr' ) {
      info = (
        <p>Catégorie d'emplacement de type {value} est l'aléa maximal sur la plage de V<sub>s30</sub> de {range[0]} à {range[1]} <abbr title="mètres par seconde">m/s</abbr>.</p>
      )
    } else {
      info = (
        <p>Site Class {value} is the maximum hazard over the V<sub>s30</sub> range of {range[0]} - {range[1]} <abbr title="meters per second">m/s</abbr>.</p>
      )
    }
  }

  return (
    <Row className='form-group'>
      <Col sm={2} className='control-label' style={{fontWeight:700}}>
        {lang.form.siteDesignationXS}
      </Col>
      <Col sm={10}>
        <ButtonToolbar>
          <ToggleButtonGroup
            type="radio"
            name="siteDesignationXS"
            value={value}
            onChange={() => {}} // suppress warning
          >
            {state.form.siteDesignationsXSOptions.map((v, i) => (
              <ToggleButton key={i} value={v} onChange={onChange}>
                {v}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </ButtonToolbar>
        {info}
      </Col>
    </Row>
  );
}

export default FormGroupSiteDesignationXS;
